import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-new-timesheet',
  templateUrl: './add-new-timesheet.component.html',
  styleUrls: ['./add-new-timesheet.component.scss']
})
export class AddNewTimesheetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
